"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jun 29 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * TierConverter.
 *
 * @author JMe
 */


var TierConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(TierConverter, _DataObjectConverter_);

  function TierConverter() {
    _classCallCheck(this, TierConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(TierConverter).apply(this, arguments));
  }

  return TierConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.TierConverter = TierConverter;